import rootStore from "csi/state/rootStore";
import { Checkbox, FormField, MultiSelect, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { REQUIRED_LABEL } from "../snapshotUtils";

export const VariantsIncludeAll = observer(() => {
	const store = useSnapshotTemplateStore();
	const { includeAllVariants, setIncludeAllVariants } = store;
	return (
		<FormField
			control={(
				<Checkbox 
					checked={includeAllVariants} 
					labelProps={{
						res: "StyleSnapshotTemplate.Attr.IncludeAllVariants",
					}} 
					onChange={setIncludeAllVariants}
				/>
			)}
			label={<Text bold res="3DVariants" />}
			labelPlacement="top"
			sx={{
				width: "fit-content",
			}}
		/>
	);
});

export const VariantsSelect = observer(() => {
	const { threeDStore: { snapshotsStore } } = rootStore;
	const store = useSnapshotTemplateStore();
	const { setSelectedVariantsOptions } = store;
	const { 
		selectedVariants,
		variantOptions,
	} = snapshotsStore;

	if (variantOptions.length === 0) {
		return null;
	}

	return (
		<FormField
			control={(
				<MultiSelect
					limitTags={2}
					onChange={setSelectedVariantsOptions}
					options={variantOptions}
					placeHolderRes="3DSelectVariants"
					value={selectedVariants}
				/>
			)}
			fullWidth
			label={<Text bold res="3DVariants" />}
			labelPlacement="top"
			required
			sx={REQUIRED_LABEL}
		/>
	);
});

